import styles from '@/styles/Home.module.scss';
import { ReactNode } from 'react';
import Link from 'next/link';
import { Box, Select, Text } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { useCookie } from 'react-use';

export function Layout(props: { children: ReactNode }) {
  const intl = useIntl();
  const { locale, push, pathname, query, asPath } = useRouter();
  const [__, setNextLocalCookie] = useCookie('NEXT_LOCALE');

  return (
    <>
      {/* 无障碍跳转链接 */}
      <a href="#main-content" className="skip-to-content">
        {intl.formatMessage({
          defaultMessage: '跳转到主要内容',
          id: 'accessibility.skip_to_content',
        })}
      </a>

      <div className={styles.main}>
        {/* 网站头部 */}
        <header>
          <Link href="/">
            <Box cursor="pointer" mb={3} as="a">
              <img
                className={styles.logo}
                src="/assets/discord-superman-logo.png"
                alt={intl.formatMessage({
                  defaultMessage: 'Discord SuperMan Logo - Discord智能聊天助手',
                  id: 'app.logo.alt',
                })}
                width="80"
                height="80"
              />
              <div className={styles.title}>
                {intl.formatMessage({
                  defaultMessage: 'Discord 智能聊天助手',
                  id: 'title',
                })}
              </div>
            </Box>
          </Link>
        </header>

        {/* 主要内容区域 */}
        <main id="main-content" role="main">
          {props.children}
        </main>

        {/* 网站底部 */}
        <footer>
          {/* 语言选择器 */}
          <Box as="section" mt={10} mb={10}>
            <Text
              as="label"
              htmlFor="language-selector"
              fontSize="sm"
              mb={2}
              display="block"
            >
              {intl.formatMessage({
                defaultMessage: '选择语言',
                id: 'language.select_label',
              })}
            </Text>
            <Select
              id="language-selector"
              size="sm"
              value={locale}
              onChange={(evt) => {
                const nextLocale = evt.target.value;
                if (!nextLocale) {
                  return;
                }
                // 设置 cookie 为了让下次打开页面时能够继续使用这里切换的语言。默认情况下 NextJS 会将默认 locale 切换到不带 /locale 的路径，这样会导致下次打开页面时，语言偏好恢复原样
                setNextLocalCookie(nextLocale);
                // change just the locale and maintain all other route information including href's query
                push({ pathname, query }, asPath, { locale: nextLocale });
              }}
              aria-label={intl.formatMessage({
                defaultMessage: '选择网站语言',
                id: 'language.select_aria_label',
              })}
            >
              <option value="en">English</option>
              <option value="zh">简体中文</option>
              <option value="zh-TW">繁體中文</option>
            </Select>
          </Box>

          {/* 版权信息 */}
          <Box
            as="section"
            textAlign="center"
            fontSize="sm"
            color="gray.600"
            py={4}
          >
            <Text>
              © {new Date().getFullYear()} Discord SuperMan.{' '}
              {intl.formatMessage({
                defaultMessage: '保留所有权利',
                id: 'footer.copyright',
              })}
            </Text>
            <Text mt={1}>
              {intl.formatMessage({
                defaultMessage: '专业的Discord自动聊天机器人解决方案',
                id: 'footer.description',
              })}
            </Text>
          </Box>
        </footer>
      </div>
    </>
  );
}
